import React from 'react'
import { withTheme } from 'styled-components';
import { ButtonReg } from 'atoms/Buttons';
import { Label } from 'atoms/Texts';
import IconPng from 'atoms/IconPng';
import {
  MainWrapper,
  IconWrapper,
  ModalBody,
  ModalFooter
} from './styles';

const ic_close = require('App/assets/vectors/ic_close.svg');
const ic_delete_confirmation = require('App/assets/vectors/ic_delete_confirmation.svg');
const ic_delete_successful = require('App/assets/vectors/ic_delete_successful.svg');

const ConfirmModal = ({
  theme,
  isSuccess,
  fnClose,
  fnConfirm,
  fnBack,
  txtConfirm,
  txtSuccess,
}) => (
  <MainWrapper>
    <IconWrapper onClick={fnClose} width={'24'} ml={'auto'}>
      <IconPng srcIcon={ic_close} ml={'auto'} size={'24'} showPointer={true} />
    </IconWrapper>
    <ModalBody>
      <IconWrapper mb={'32px'}>
        <IconPng
          srcIcon={!isSuccess ? ic_delete_confirmation : ic_delete_successful}
          size={'140'}
          h={'122'}
          mx={'auto'} />
      </IconWrapper>
      <Label size={'20px'}>
        {!isSuccess ? 'Confirmation!' : 'Successfully'}
      </Label>
      <Label size={'12px'} weight={'400'} color={theme.mocaGrey}>
        {!isSuccess ? txtConfirm : txtSuccess}
      </Label>
    </ModalBody>
    <ModalFooter>
      {
        !isSuccess ?
          <>
            <ButtonReg
              onClick={fnConfirm}
              btnTxt="Yes"
              transparent
            />
            <ButtonReg
              onClick={fnClose}
              btnTxt="No"
            />
          </>
          :
          <ButtonReg
            onClick={fnBack}
            btnTxt="Back"
          />
      }
    </ModalFooter>
  </MainWrapper>
)

export default withTheme(ConfirmModal)